import {Injectable} from "@angular/core";
import {AppSettings} from "../AppSettings";

@Injectable()
export class BrandingService implements NPS.Common.Branding.IBrandingService {
    getSystemConfiguration(): NPS.Common.Branding.ISystemConfiguration {
        return AppSettings.systemConfiguration;
    }

    updateDocumentTitle(title: string): void {
        let doc=<any> $(document).get(0);
        doc.title = title;
    }
}



// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Branding/BrandingService.ts